jQuery(function ($) {
  const timer = setInterval(function () {
    const $target = $('.ss_enquete_field').filter(function () {
      return $(this).find('.ss_enquete_title').text().includes('高関心ユーザーフラグ');
    });

    if ($target.length) {
      $target.hide();
      clearInterval(timer);
    }
  }, 200);
});

jQuery(function ($) {
  const timer = setInterval(function () {
    const $textarea = $('textarea[name="Public::EmbeddedApplication::Userenquete_D__P__D_Enquete.attribute22084"]');

    if ($textarea.length) {
      $textarea.attr(
        'placeholder',
        'サービス内容について詳しく知りたい、現在の課題、他法人の事例など、箇条書きでも構いません'
      );

      clearInterval(timer);
    }
  }, 200);
});